const mySubmissionsPreID = (id: string) => `mySubmissions-${id}`;

export const mySubmissionElementIDs = {
  // favepay
  favePayTab: mySubmissionsPreID('favePayTab'),
  favePayCompanyFilterIcon: mySubmissionsPreID('favePayCompanyFilterIcon'),
  favePaySubmissionStatusFilterIcon: mySubmissionsPreID(
    'favePaySubmissionStatusFilterIcon',
  ),
  favePayActionBtn: mySubmissionsPreID('favePayActionBtn'),
  favePayViewBtn: mySubmissionsPreID('favePayViewBtn'),
  favePayEditResubmitBtn: mySubmissionsPreID('favePayEditResubmitBtn'),
  favePayCopyLinkBtn: mySubmissionsPreID('favePayCopyLinkBtn'),
  favePayDownloadContractBtn: mySubmissionsPreID('favePayDownloadContractBtn'),
  // deals
  dealsTab: mySubmissionsPreID('dealsTab'),
  dealsSubmissionStatusFilterIcon: mySubmissionsPreID(
    'dealsSubmissionStatusFilterIcon',
  ),
  dealsActionBtn: mySubmissionsPreID('dealsActionBtn'),
  dealsViewBtn: mySubmissionsPreID('dealsViewBtn'),
  dealsEditResubmitBtn: mySubmissionsPreID('dealsEditResubmitBtn'),
  dealsCopyLinkBtn: mySubmissionsPreID('dealsCopyLinkBtn'),
  dealsDownloadContractBtn: mySubmissionsPreID('dealsDownloadContractBtn'),
  dealsDuplicateBtn: mySubmissionsPreID('dealsDuplicateBtn'),
  dealsCopyIDBtn: mySubmissionsPreID('dealsCopyIDBtn'),
  // ecards
  eCardsTab: mySubmissionsPreID('eCardsTab'),
  eCardsSubmissionStatusFilterIcon: mySubmissionsPreID(
    'eCardsSubmissionStatusFilterIcon',
  ),
  eCardsActionBtn: mySubmissionsPreID('eCardsActionBtn'),
  eCardsViewBtn: mySubmissionsPreID('eCardsViewBtn'),
  eCardsEditResubmitBtn: mySubmissionsPreID('eCardsEditResubmitBtn'),
  eCardsCopyLinkBtn: mySubmissionsPreID('eCardsCopyLinkBtn'),
  eCardsDownloadContractBtn: mySubmissionsPreID('eCardsDownloadContractBtn'),
  eCardsDuplicateBtn: mySubmissionsPreID('eCardsDuplicateBtn'),
  eCardsCopyIDBtn: mySubmissionsPreID('eCardsCopyIDBtn'),
  // bnpl
  bnplTab: mySubmissionsPreID('bnplTab'),
  // payment mode
  paymentModeTab: mySubmissionsPreID('paymentModeTab'),
  paymentModeSubmissionStatusFilterIcon: mySubmissionsPreID(
    'paymentModeSubmissionStatusFilterIcon',
  ),
  paymentModeActionBtn: mySubmissionsPreID('paymentModeActionBtn'),
  paymentModeViewBtn: mySubmissionsPreID('paymentModeViewBtn'),
  paymentModeEditResubmitBtn: mySubmissionsPreID('paymentModeEditResubmitBtn'),
  paymentModeCopyLinkBtn: mySubmissionsPreID('paymentModeCopyLinkBtn'),
  paymentModeDownloadContractBtn: mySubmissionsPreID(
    'paymentModeDownloadContractBtn',
  ),
  paymentModeEditAndResubmitBtn: mySubmissionsPreID(
    'paymentModeEditAndResubmitBtn',
  ),
  // ipp
  ippTab: mySubmissionsPreID('ippTab'),
  ippSortSubmissionDateBtn: mySubmissionsPreID('ippSortSubmissionDateBtn'),
  ippSubmissionStatusFilterIcon: mySubmissionsPreID(
    'ippSubmissionStatusFilterIcon',
  ),
  ippActionBtn: mySubmissionsPreID('ippActionBtn'),
  ippViewBtn: mySubmissionsPreID('ippViewBtn'),
  ippEditResubmitBtn: mySubmissionsPreID('ippEditResubmitBtn'),
  ippCopyLinkBtn: mySubmissionsPreID('ippCopyLinkBtn'),
  ippDownloadContractBtn: mySubmissionsPreID('ippDownloadContractBtn'),
  // contract migration
  contractMigrationTab: mySubmissionsPreID('contractMigrationTab'),
  contractMigrationSortSubmissionDateBtn: mySubmissionsPreID(
    'contractMigrationSortSubmissionDateBtn',
  ),
  contractMigrationSubmissionStatusFilterIcon: mySubmissionsPreID(
    'contractMigrationSubmissionStatusFilterIcon',
  ),
  contractMigrationActionBtn: mySubmissionsPreID('contractMigrationActionBtn'),
  contractMigrationDownloadContractBtn: mySubmissionsPreID(
    'contractMigrationDownloadContractBtn',
  ),
  contractMigrationCancelContractBtn: mySubmissionsPreID(
    'contractMigrationCancelContractBtn',
  ),
  // fave pass
  favePassTab: mySubmissionsPreID('favePassTab'),
  favePassSubmissionStatusFilterIcon: mySubmissionsPreID(
    'favePassSubmissionStatusFilterIcon',
  ),
  favePassActionBtn: mySubmissionsPreID('favePassActionBtn'),
  favePassViewBtn: mySubmissionsPreID('favePassViewBtn'),
  favePassEditResubmitBtn: mySubmissionsPreID('favePassEditResubmitBtn'),
  favePassCopyLinkBtn: mySubmissionsPreID('favePassCopyLinkBtn'),
  favePassDownloadContractBtn: mySubmissionsPreID(
    'favePassDownloadContractBtn',
  ),
  // stamp card
  stampCardTab: mySubmissionsPreID('stampCardTab'),
  stampCardSubmissionStatusFilterIcon: mySubmissionsPreID(
    'stampCardSubmissionStatusFilterIcon',
  ),
  stampCardActionBtn: mySubmissionsPreID('stampCardActionBtn'),
  stampCardViewBtn: mySubmissionsPreID('stampCardViewBtn'),
  stampCardEditResubmitBtn: mySubmissionsPreID('stampCardEditResubmitBtn'),
  stampCardCopyLinkBtn: mySubmissionsPreID('stampCardCopyLinkBtn'),
  stampCardDownloadContractBtn: mySubmissionsPreID(
    'stampCardDownloadContractBtn',
  ),
};
